import { createSvgIcon } from '@material-ui/core/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M12 10.557c.629 0 1.141-.512 1.141-1.141S12.629 8.275 12 8.275s-1.141.512-1.141 1.141.512 1.141 1.141 1.141z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5zm0 2.909c1.521 0 2.757 1.237 2.757 2.757S13.521 12.172 12 12.172c-1.52 0-2.757-1.236-2.757-2.756S10.48 6.659 12 6.659zm2.716 7.099a5.179 5.179 0 0 1-1.601.663l1.541 1.541a.806.806 0 1 1-1.141 1.142L12 15.59l-1.514 1.514a.808.808 0 0 1-1.143-1.142l1.541-1.541a5.179 5.179 0 0 1-1.601-.663.807.807 0 0 1 .86-1.367 3.5 3.5 0 0 0 3.712 0 .807.807 0 0 1 .861 1.367z"
  })]
}), 'OdnoklassnikiRing');